import isAuth from "@/middleware/isAuth";
import isParent from "@/middleware/isParent";
import requireParentChild from "@/middleware/requireParentChild";

const gate = [isAuth, isParent];
const childGate = [isAuth, isParent, requireParentChild];

export default [
  {
    path: "/parent",
    component: () =>
      import(/* webpackChunkName: "parent-shell" */ "@/layouts/parent.vue"),
    meta: {
      layout: "plain",
      portal: "parent",
    },
    children: [
      {
        path: "",
        name: "ParentChildren",
        component: () =>
          import(
            /* webpackChunkName: "parent-children" */ "@/views/parent/children.vue"
          ),
        meta: {
          middleware: gate,
          titleKey: "parent_pick_child",
          descriptionKey: "parent_pick_child_hint",
        },
      },
      {
        path: "home",
        name: "ParentHome",
        component: () =>
          import(
            /* webpackChunkName: "parent-home" */ "@/views/parent/home.vue"
          ),
        meta: {
          middleware: childGate,
          requiresChild: true,
          titleKey: "parent_home",
          descriptionKey: "parent_home_hint",
        },
      },
      {
        path: "announcements",
        name: "ParentAnnouncements",
        component: () =>
          import(
            /* webpackChunkName: "parent-announcements" */ "@/views/parent/announcements.vue"
          ),
        meta: {
          middleware: childGate,
          requiresChild: true,
          titleKey: "parent_announcements",
          descriptionKey: "parent_home_hint",
        },
      },
      {
        path: "notes",
        name: "ParentNotes",
        component: () =>
          import(
            /* webpackChunkName: "parent-notes" */ "@/views/parent/notes.vue"
          ),
        meta: {
          middleware: childGate,
          requiresChild: true,
          titleKey: "notes",
          descriptionKey: "parent_notes_hint",
        },
      },
      {
        path: "timetable",
        name: "ParentTimetable",
        component: () =>
          import(
            /* webpackChunkName: "parent-timetable" */ "@/views/parent/timetable.vue"
          ),
        meta: {
          middleware: childGate,
          requiresChild: true,
          titleKey: "parent_timetable",
          descriptionKey: "parent_timetable_hint",
        },
      },
      {
        path: "exams",
        name: "ParentExams",
        component: () =>
          import(
            /* webpackChunkName: "parent-exams" */ "@/views/parent/exams.vue"
          ),
        meta: {
          middleware: childGate,
          requiresChild: true,
          titleKey: "exams",
          descriptionKey: "parent_exams_hint",
        },
      },
      {
        path: "attendance",
        name: "ParentAttendance",
        component: () =>
          import(
            /* webpackChunkName: "parent-attendance" */ "@/views/parent/attendance.vue"
          ),
        meta: {
          middleware: childGate,
          requiresChild: true,
          titleKey: "parent_attendance",
          descriptionKey: "parent_attendance_hint",
        },
      },
      {
        path: "complaints",
        name: "ParentComplaints",
        component: () =>
          import(
            /* webpackChunkName: "parent-complaints" */ "@/views/parent/complaints.vue"
          ),
        meta: {
          middleware: childGate,
          requiresChild: true,
          titleKey: "parent_complaint",
          descriptionKey: "parent_complaint_hint",
        },
      },
      {
        path: "bus",
        name: "ParentBus",
        component: () =>
          import(/* webpackChunkName: "parent-bus" */ "@/views/parent/bus.vue"),
        meta: {
          middleware: childGate,
          requiresChild: true,
          titleKey: "bus",
          descriptionKey: "parent_bus_hint",
        },
      },
    ],
  },
];
